import R from "ramda";
import parseStringToOject from "./parseStringToOject";

export default R.map(rule => ({
  ...rule,
  conditionsStr: parseStringToOject(rule.conditionsStr),
  conditions: parseStringToOject(rule.conditions)
}));
